import { apiClient as api } from "./httpClient";

/** Linha da página Aniversariantes (RN-524). Nome completo; contato do responsável quando houver. */
export interface BirthdayRow {
  patientId: string;
  birth: string;
  age: number | null;
  name: string;
  gender: string | null;
  responsibleName: string | null;
  /** telefone de exibição, com DDI */
  phone: string | null;
  /** o mesmo telefone em dígitos E.164, para o wa.me */
  whatsAppPhone: string | null;
  email: string | null;
  isToday: boolean;
}

export interface BirthdaysResponse {
  from: string;
  to: string;
  items: BirthdayRow[];
}

const range = (from?: string, to?: string) => {
  const params = new URLSearchParams();
  if (from) params.set("from", from);
  if (to) params.set("to", to);
  const q = params.toString();
  return q ? `?${q}` : "";
};

export const birthdaysService = {
  list: async (from?: string, to?: string): Promise<BirthdaysResponse> => {
    const response = await api.get(`/birthdays${range(from, to)}`);
    return response.data;
  },

  exportXlsx: async (from?: string, to?: string): Promise<Blob> => {
    const response = await api.get(`/birthdays/export${range(from, to)}`, { responseType: "blob" });
    return response.data;
  },
};
